import React, { useEffect, useState } from 'react';
import GoalOptions from '../GoalOptions';

const inputCls =
  'shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline';

// Настройки email-кампании: название, отправитель (домен / From Address / From Name
// из модуля «Отправитель»), цель, окно атрибуции и время отправки — как у SMS.
const EmailCampaignSettings = ({ formData, updateFormData, setIsFormValid }) => {
  const [senders, setSenders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/v1/email_senders')
      .then((r) => r.json())
      .then((data) => setSenders(data.senders || []))
      .finally(() => setLoading(false));
  }, []);

  const sender = senders.find((s) => String(s.id) === String(formData.emailSenderId));

  useEffect(() => {
    if (sender && formData.emailSenderLabel !== sender.from_address) {
      updateFormData({ emailSenderLabel: sender.from_address, emailSenderName: sender.from_name });
    }
  }, [sender]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setIsFormValid(!!(formData.name?.trim() && sender));
  }, [formData.name, sender, setIsFormValid]);

  const handleChange = (e) => updateFormData({ [e.target.name]: e.target.value });

  return (
    <div className='space-y-6'>
      <div>
        <label className='block text-gray-700 text-sm font-bold mb-2' htmlFor='name'>Campaign Name *</label>
        <input id='name' name='name' type='text' value={formData.name} onChange={handleChange} className={inputCls} placeholder='Enter campaign name' />
      </div>

      <div>
        <label className='block text-gray-700 text-sm font-bold mb-2' htmlFor='emailSenderId'>Email sender *</label>
        <select id='emailSenderId' name='emailSenderId' value={formData.emailSenderId || ''} onChange={handleChange} className={`${inputCls} bg-white`}>
          <option value=''>{loading ? 'Loading…' : 'Select a sender…'}</option>
          {senders.map((s) => (
            <option key={s.id} value={s.id}>{s.from_name} &lt;{s.from_address}&gt;</option>
          ))}
        </select>
        {sender && (
          <div className='mt-2 grid grid-cols-3 gap-2 text-xs'>
            <div className='bg-slate-50 rounded px-2 py-1.5'><span className='text-slate-500'>Domain</span><div className='text-slate-900'>{sender.domain}</div></div>
            <div className='bg-slate-50 rounded px-2 py-1.5'><span className='text-slate-500'>From Address</span><div className='text-slate-900'>{sender.from_address}</div></div>
            <div className='bg-slate-50 rounded px-2 py-1.5'><span className='text-slate-500'>From Name</span><div className='text-slate-900'>{sender.from_name}</div></div>
          </div>
        )}
        {!loading && senders.length === 0 && (
          <p className='mt-1 text-xs text-amber-700'>
            No active email sender on a verified domain. Set one up in Senders → Email.
          </p>
        )}
      </div>

      <div className='grid grid-cols-2 gap-4'>
        <div>
          <label className='block text-gray-700 text-sm font-bold mb-2' htmlFor='goalType'>Campaign Goal</label>
          <select id='goalType' name='goalType' value={formData.goalType} onChange={handleChange} className={`${inputCls} bg-white`}>
            <GoalOptions />
          </select>
        </div>
        <div>
          <label className='block text-gray-700 text-sm font-bold mb-2' htmlFor='attributionWindowHours'>Attribution window (hours)</label>
          <select id='attributionWindowHours' name='attributionWindowHours' value={formData.attributionWindowHours} onChange={handleChange} className={`${inputCls} bg-white`}>
            {[1, 2, 3, 4, 5, 6].map((h) => <option key={h} value={h}>{h}</option>)}
          </select>
        </div>
      </div>

      <div>
        <label className='block text-gray-700 text-sm font-bold mb-2'>Send Time</label>
        <div className='space-y-4'>
          {[['now', 'Send Now'], ['later', 'Schedule for Later']].map(([value, label]) => (
            <div key={value} className='flex items-center'>
              <input type='radio' id={`email-send-${value}`} name='sendTime' value={value} checked={formData.sendTime === value} onChange={handleChange} className='h-4 w-4 text-blue-600 border-gray-300' />
              <label htmlFor={`email-send-${value}`} className='ml-2 block text-gray-700'>{label}</label>
            </div>
          ))}
          {formData.sendTime === 'later' && (
            <div className='ml-6'>
              <input type='datetime-local' name='scheduledTime' value={formData.scheduledTime} onChange={handleChange} className={inputCls} min={new Date().toISOString().slice(0, 16)} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailCampaignSettings;
